import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

/**
 * Wraps the component in a `<div data-use-bs>` to put it in Bootstrap scope
 */
export function BootstrapRoute({
  component: Component,
  render,
  children,
  ...rest
}: RouteProps) {
  const renderContent = (props: RouteComponentProps) => {
    if (Component) return <Component {...props} />;
    if (render) return render(props);
    if (typeof children === 'function') return children(props);
    return children;
  };

  return (
    <Route
      {...rest}
      render={(props) => <div data-use-bs>{renderContent(props)}</div>}
    />
  );
}
